import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Data Bank Pusat"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Daftar Bank Pusat")
  ])
], -1)
const _hoisted_3 = { class: "card-header border-0 pt-5" }
const _hoisted_4 = { class: "card-title align-items-start flex-column" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_6 = { class: "d-flex px-8" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex mx-9 position-relative"
}
const _hoisted_8 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_10 = { class: "card-body py-3" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Bank"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Area"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Cabang"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Funding"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Siswa"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "row mt-5 mb-5" }
const _hoisted_35 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_36 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_37 = ["label", "value"]
const _hoisted_38 = { class: "p-3" }
const _hoisted_39 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_40 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/bank-center/add'))),
            class: "btn btn-sm btn-primary"
          }, " Tambah Bank Pusat ")
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light",
          style: {"font-weight":"400","margin-top":"0px"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showHideFilter && _ctx.showHideFilter(...args)))
        }, " Filter "),
        (_ctx.showFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control w-250px ps-15",
                  placeholder: "Cari Nama Bank",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.eventDelaySearch(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.name]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _hoisted_13,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_15, _toDisplayString(item.bankName), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.totalAreas), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.totalBranchs), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item.totalFundings), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.totalSchools), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.totalStudents), 1),
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (
                      _ctx.$router.push(
                        '/superadmin/bank-center/detail/' + item.bankId
                      )
                    )
                        }, _hoisted_24, 8, _hoisted_22),
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Edit",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (
                      _ctx.$router.push('/superadmin/bank-center/' + item.bankId)
                    )
                        }, _hoisted_27, 8, _hoisted_25),
                        (_ctx.isShow)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.handleDelete(index, item))
                            }, _hoisted_30, 8, _hoisted_28))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_31, _hoisted_33))
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_37))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("ul", _hoisted_40, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}